import { render } from "./ListExam.vue?vue&type=template&id=222e0998"
import script from "./ListExam.vue?vue&type=script&lang=js"
export * from "./ListExam.vue?vue&type=script&lang=js"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-teacher-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__